import { Injectable } from '@angular/core';
import { WebsocketService } from './websocket.service';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class MessageService {
    messages: Subject<any>;

    constructor(private webSocketService: WebsocketService) {
        this.messages = <Subject<any>>webSocketService.connect().map(
            (response: any): any => {
                return response;
            }
        );
    }

    sendMessage(message) {
        this.messages.next(message);
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/_services/message.service.ts